export default "__VITE_ASSET__ba9b8fad__"